module.exports = __webpack_public_path__ + "img/icon-commented.c7621b27.svg";